import React from 'react';
import { Redirect } from 'wouter';
import { useAuth } from '../../contexts/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();

  // Attendre que l'état d'auth soit chargé
  if (loading) {
    return <div className="private-route-loading">Chargement...</div>;
  }

  // Rediriger vers login si non connecté
  if (!user) {
    return <Redirect to="/login" />;
  }

  // Rediriger vers verify-email si email non vérifié
  if (!user.emailVerified) {
    return <Redirect to="/verify-email" />;
  }

  // Afficher le contenu protégé
  return <>{children}</>;
};

export default PrivateRoute;
